import {
  GetMyNoteInClasseQuery,
  NoteEntity
} from '../../../graphql/generated/graphql';
import { ToRequiredType } from '../../../types/typeDef';
import { NoteDef } from '../../../types/note/note.def';

export const getNoteDefFromQuery: (
  note: GetMyNoteInClasseQuery['getMyNoteInClasse']['note']
) => NoteDef = note => {
  if (!note) return;
  return {
    id: note.id,
    ...(note.attributes as ToRequiredType<Partial<NoteEntity>['attributes']>)
  };
};
